module.exports = __webpack_public_path__ + "static/img/history.a6b5e89c.png";